import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { ICampaignPromoCodesService } from "@shared/interfaces/campaign-promo-codes-service.interface";
import {
  CampaignPromoCodeDto,
  CampaignPromoCodesListDto,
  CreateCampaignPromoCodeDto,
  ListCampaignPromoCodesDto,
} from "@shared/types/campaign-promo-codes/campaign-promo-code.dto";

@appInjectable()
export class CampaignPromoCodesService
  extends BaseService
  implements ICampaignPromoCodesService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  list: ICampaignPromoCodesService["list"] = async (params) => {
    const { withCpaRedemption, ...rest } = params;
    const { data } = await this.httpClient.get<{
      data: CampaignPromoCodesListDto;
    }>("/campaign-promo-codes", {
      params: {
        ...rest,
        ...(withCpaRedemption ? { withCpaRedemption: "true" } : {}),
      },
      baseURL: this.baseURL,
    });
    return data.data;
  };

  create: ICampaignPromoCodesService["create"] = async (body) => {
    const { data } = await this.httpClient.post<{
      data: CampaignPromoCodeDto[];
    }>("/campaign-promo-codes", body, { baseURL: this.baseURL });
    return data.data;
  };
}
